var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isDashbord)?_c('div',{staticClass:"main-menu-grouping"},[_c('main-menu-grouping-desktop',{staticClass:"hidden-sm-and-down"}),_c('main-menu-grouping-mobile',{staticClass:"hidden-md-and-up"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }